module.exports = __webpack_public_path__ + "media/images/icons/twotone/bank-15bf01ca1e5abfa6d940106b7a981bfe.svg";